import React, {Component, type ReactNode} from 'react'

type FilterButtonProps = {
    title: string
    status?: boolean
    onChange: (event: boolean) => void
}

type FilterButtonState = {
    selected: boolean
}

export class FilterButton extends Component<FilterButtonProps, FilterButtonState> {
    constructor(props: FilterButtonProps) {
        super(props)
        this.state = {
            selected: this.props.status || false
        }
    }

    componentDidUpdate() {
        if(this.props.status !== this.state.selected) {
            this.setState({
                selected: this.props.status
            })
        }
    }

    onChange = async () => {
        const newState = !this.state.selected
        this.setState({
            selected: newState
        })
        this.props.onChange(newState)
    }

    render(): ReactNode {
        return (
            <div
                data-testid={'filter-button'}
                className={`text-sm text-primary inline-block md:hidden border rounded-full py-2 px-3 mb-2 mr-1 cursor-pointer${this.state.selected ? ' text-white bg-primary border-success' : ' border-neutral-500'}`}
                onClick={this.onChange} onKeyDown={this.onChange}>{this.props.title}</div>
        )
    }
}

